import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ManagedUserGroup,
  MutationManagedUserGroupCreateV2Args,
  MutationManagedUserGroupUpdateArgs,
  QueryManagedUserGroupArgs,
} from "types/generated";

import { ManagedUserGroupView } from "./types";

type GetManagedUserGroupsData = {
  managedUserGroups: ManagedUserGroupView[];
};

export const GET_MANAGED_USER_GROUPS: TypedDocumentNode<GetManagedUserGroupsData> = gql`
  query GetManagedUserGroupsV2 {
    managedUserGroups {
      id
      groupName
      identityProvider
      lastLoginTime
      memberCount
      spaceCount
      status
      description
    }
  }
`;

type GetManagedUserGroupData = {
  managedUserGroup: ManagedUserGroupView;
};

export const GET_MANAGED_USER_GROUP: TypedDocumentNode<
  GetManagedUserGroupData,
  QueryManagedUserGroupArgs
> = gql`
  query GetManagedUserGroup($id: ID!) {
    managedUserGroup(id: $id) {
      id
      groupName
      identityProvider
      lastLoginTime
      memberCount
      members
      spaceCount
      status
      description
      accessRules {
        space
        spaceAccessLevel
      }
    }
  }
`;

type CreateManagedUserGroupData = {
  managedUserGroupCreate: Pick<ManagedUserGroup, "id" | "groupName" | "description">;
};

export const CREATE_MANAGED_USER_GROUP: TypedDocumentNode<
  CreateManagedUserGroupData,
  MutationManagedUserGroupCreateV2Args
> = gql`
  mutation CreateManagedUserGroupV2($input: ManagedUserGroupCreateInputV2!) {
    managedUserGroupCreateV2(input: $input) {
      id
      groupName
      description
    }
  }
`;

type UpdateManagedUserGroupData = {
  managedUserGroupUpdate: Pick<ManagedUserGroup, "id" | "groupName" | "description">;
};

export const UPDATE_MANAGED_USER_GROUP: TypedDocumentNode<
  UpdateManagedUserGroupData,
  MutationManagedUserGroupUpdateArgs
> = gql`
  mutation UpdateManagedUserGroup($input: ManagedUserGroupUpdateInput!) {
    managedUserGroupUpdate(input: $input) {
      id
      groupName
      description
    }
  }
`;
